import { render, staticRenderFns } from "./ReportContraventionSearch.vue?vue&type=template&id=6beb0630&"
import script from "./ReportContraventionSearch.vue?vue&type=script&lang=js&"
export * from "./ReportContraventionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports